import { Badge } from "@workanywhere/ui";
import { cn } from "@workanywhere/ui";
import type { ConnectionState } from "./use-agent-updates";

export function ConnectionBadge({ state }: { state: ConnectionState }) {
  return (
    <Badge variant="outline" className="gap-2 capitalize">
      <span
        className={cn(
          "size-2 rounded-full",
          state === "connected" && "bg-emerald-500",
          state === "connecting" && "bg-amber-500",
          state === "disconnected" && "bg-destructive",
        )}
      />
      {state}
    </Badge>
  );
}

export function Metric({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex min-h-10 items-center justify-between gap-3 rounded-md border bg-card px-3 py-2">
      <div className="shrink-0 text-xs text-muted-foreground">{label}</div>
      <div className="min-w-0 truncate text-sm font-semibold tabular-nums">{value}</div>
    </div>
  );
}

export function SummaryLine({ label, value }: { label: string; value: string }) {
  return (
    <div className="grid grid-cols-[92px_minmax(0,1fr)] gap-3 text-sm">
      <span className="text-muted-foreground">{label}</span>
      <span className="truncate font-medium">{value}</span>
    </div>
  );
}
